import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/concrete-calculator',
  component: () => import('../../routes/ConcreteCalculator.svelte'),
  card: {
    id: 'concrete-calculator',
    title: 'Concrete Calculator',
    description: 'Calculate how many bags of concrete you need for a slab, footing, or post. Covers 60 lb and 80 lb bags at various depths.',
    icon: 'construction',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/concrete-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Concrete Calculator – Bags Needed for Slabs, Footings & Posts',
    description:
      'Free concrete calculator to estimate bags needed for any project. Works with 60 lb and 80 lb bags at 4-inch, 6-inch, and other common depths.',
  },
};

export default meta;
